import { ApolloError } from '@apollo/client';

import { useErpGroupSurveyAssignmentsQuery } from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { IGroupSurveyAssignment } from './surveyModel';

/** `refetch` выключенного запроса — пустышка: под skip Apollo 3.3 ушёл бы в сеть. */
const SKIPPED_REFETCH = (): void => undefined;

const EMPTY_ASSIGNMENTS: IGroupSurveyAssignment[] = [];

interface IGroupSurveyAssignmentsHook {
  assignments: IGroupSurveyAssignment[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0011 — the «Опросы» tab of the group card: every survey attachment of
 * one group with its trigger lesson and responded/eligible counters.
 */
export const useGroupSurveyAssignments = (
  groupId?: string,
  /** Роль без `SURVEY_MANAGER_ROLES` (`canSeeSurveysTab`) — не запрашивать. */
  skip?: boolean,
): IGroupSurveyAssignmentsHook => {
  const skipped = !groupId || Boolean(skip);
  const { data, loading, error, refetch } = useErpGroupSurveyAssignmentsQuery({
    variables: { groupId: groupId || '' },
    skip: skipped,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  // Stable identity — a fresh `() => refetch()` per render would loop any
  // consumer that lists it in a memo/effect dep (see useSurveys for the
  // react-table variant of this footgun).
  const stableRefetch = useStableRefetch(skipped ? SKIPPED_REFETCH : refetch);

  return {
    assignments: data?.groupSurveyAssignments ?? EMPTY_ASSIGNMENTS,
    loading,
    error,
    refetch: stableRefetch,
  };
};
